








































import breakpoints from 'library/styles/vars/breakpoints.json'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import { setupWindowResizeHandler } from '~/services/utils.coffee'
import breakpointWatcherMixin from './breakpoint-watcher-mixin.coffee'

export default
	name: 'BaseCarousel'

	mixins: [ breakpointWatcherMixin ]

	components: {
		VueSlickCarousel
	}

	props:
		# Should carousel slides loop
		loop:
			type: Boolean
			default: false

		# Determine slide width at various breakpoints
		slidesToShow:
			type: Object
			default:
				desktopUp: 4
				desktopDown: 4
				tabletLandscapeDown: 3
				tabletDown: 2
				mobileLandscapeDown: 2
				mobileDown: 1

		# Total number of slides.
		# We use this and `slidesToShow` to determine if there's overflow.
		slideCount:
			type: Number

		# Peek Next Slide: Shrink slide width in order to show a bit of the next slide at the far right edge.
		# Set to `false` to enable true full-width slides.
		peekNextSlide:
			type: Boolean
			default: false

		# Force slides to be equal height by setting their container height
		setEqualHeight:
			type: Boolean
			default: false

		# Let slides determine their own width
		variableWidth:
			type: Boolean
			default: false

	data: ->
		# How many slides are currently showing, based on the `slidesToShow` prop and the current breakpoint.
		currentSlidesToShow: 1

		# Which DOM element we should set the `height` inline style on.  This makes all slides equal height.
		slideWrapper: null

		# Whether the user is currently swiping the slick-carousel.
		# While swiping, cover up slides with a transparent pseudoelement.
		# Fixes bug where swiping triggers clicks on slides that contain links.
		# https://github.com/gs-shop/vue-slick-carousel/issues/117#issuecomment-742017081
		dragging: false

	computed:
		carouselClasses: -> [
			if @peekNextSlide then 'peek-next-slide' else 'no-peek-next-slide'
		]

		slickClasses: -> [
			if @dragging then 'is-dragging' else 'not-dragging'
		]

		# Whether the slides are overflowing the container.
		slidesAreOverflowing: -> @slideCount > @currentSlidesToShow

		responsiveConfig: ->
			result = []
			# Each breakpoint block styles the breakpoint downwards (like a max-width media query)
			if @slidesToShow.desktopDown then result.push {
				breakpoint: parseInt breakpoints['desktop']
				settings:
					slidesToShow: @slidesToShow.desktopDown
			}
			if @slidesToShow.tabletLandscapeDown then result.push {
				breakpoint: parseInt breakpoints['tablet-landscape']
				settings:
					slidesToShow: @slidesToShow.tabletLandscapeDown
			}
			if @slidesToShow.tabletDown then result.push {
				breakpoint: parseInt breakpoints['tablet']
				settings:
					slidesToShow: @slidesToShow.tabletDown
			}
			if @slidesToShow.mobileLandscapeDown then result.push {
				breakpoint: parseInt breakpoints['mobile-landscape']
				settings:
					slidesToShow: @slidesToShow.mobileLandscapeDown
			}
			if @slidesToShow.mobileDown then result.push {
				breakpoint: parseInt breakpoints['mobile']
				settings:
					slidesToShow: @slidesToShow.mobileDown
			}
			return result

	mounted: ->
		@updateCurrentSlidesToShow()
		if @setEqualHeight
			@cleanupResize = setupWindowResizeHandler @onResize, null, 500

	beforeDestroy: ->
		@cleanupResize?()
		if @dragTimeout? then clearTimeout @dragTimeout

	watch:
		breakpoints:
			deep: true
			handler: -> @updateCurrentSlidesToShow()

		slidesAreOverflowing: -> @updateElements()


	methods:

		onResize: ->
			@updateWrapperHeight()

		# Set @currentSlidesToShow according to the current breakpoint we're in
		updateCurrentSlidesToShow: ->
			if @breakpoints.isDesktopUp && @slidesToShow.desktopUp
				@currentSlidesToShow = @slidesToShow.desktopUp
			if @breakpoints.isTabletLandscapeUp && @slidesToShow.desktopDown
				@currentSlidesToShow = @slidesToShow.desktopDown
			else if @breakpoints.isTabletUp && @slidesToShow.tabletLandscapeDown
				@currentSlidesToShow = @slidesToShow.tabletLandscapeDown
			else if @breakpoints.isMobileLandscapeUp && @slidesToShow.tabletDown
				@currentSlidesToShow = @slidesToShow.tabletDown
			else if @breakpoints.isMobileUp && @slidesToShow.mobileLandscapeDown
				@currentSlidesToShow = @slidesToShow.mobileLandscapeDown
			else if @slidesToShow.mobileDown
				@currentSlidesToShow = @slidesToShow.mobileDown
			else
				@currentSlidesToShow = @slidesToShow.desktopUp

			# When we cross a breakpoint, Slick re-inits and we lose our refs, so we have to get fresh elements again.
			# Wait until next render so the elements exist.
			@$nextTick ->
				@updateElements()
				@updateWrapperHeight()

		updateElements: ->
			if @slidesAreOverflowing && @setEqualHeight
				# The slides have started overflowing.
				@$nextTick ->
					# Wait until next render so the elements exist.
					@slideWrapper = @$el.querySelector('.slick-track')
					@updateWrapperHeight()

			if !@slidesAreOverflowing && @setEqualHeight
				# The slides have stopped overflowing.
				@$nextTick ->
					# Wait until next render so the elements exist.
					@slideWrapper = @$refs.carousel
					@updateWrapperHeight()

		updateWrapperHeight: ->
			# Despite the slide wrapper being `align-items: stretch`, the slides are different height.
			# Set `height` inline style on the slide wrapper, which makes all the slides the same height.
			return unless @slideWrapper?
			# Set `height` inline style to slideWrapper's natural height.
			@slideWrapper?.style?.height = ''
			@slideWrapper?.style?.height = "#{@slideWrapper.clientHeight}px"

		# Wait a short time before disabling clicks.
		# This allows the user to perform normal click events on slides that contain links.
		dragStart: ->
			return if @dragging
			@dragTimeout = setTimeout =>
				@dragging = true
			, 200

		# Wait a short time after the drag ends before re-enabling clicks.
		# Fixes bug where swiping triggers clicks on slides that contain links.
		dragEnd: ->
			return unless @dragging
			@dragTimeout = setTimeout =>
				@dragging = false
			, 200

